import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2f526238")

_pushScopeId("data-v-2f526238")
const _hoisted_1 = /*#__PURE__*/_createVNode("a", { style: {"color":"#fff","text-decoration":"none"} }, "安装包下载", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("删除数据")
const _hoisted_3 = { class: "corePerformance" }
const _hoisted_4 = { class: "flex_bt" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "单条日志统计", -1)
const _hoisted_7 = {
  class: "spacName visit-record1",
  style: {"width":"100%"}
}
const _hoisted_8 = { class: "flex_bt" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "flex_bt" }
const _hoisted_11 = { class: "corePerformance" }
const _hoisted_12 = { class: "flex_bt" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "单条日志对比", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_16 = { class: "spacName visit-record1" }
const _hoisted_17 = /*#__PURE__*/_createVNode("textarea", { id: "input" }, "这是幕后黑手", -1)
const _hoisted_18 = { class: "corePerformance" }
const _hoisted_19 = { class: "flex_bt" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, "进程日志统计", -1)
const _hoisted_22 = {
  class: "spacName visit-record1",
  style: {"width":"100%"}
}
const _hoisted_23 = { class: "corePerformance" }
const _hoisted_24 = { class: "flex_bt" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("span", null, "进程日志对比", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_28 = { class: "spacName visit-record1" }
const _hoisted_29 = { class: "corePerformance" }
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("span", null, "趋势图", -1)
const _hoisted_32 = { class: "gameTable spacName" }
const _hoisted_33 = { style: {"font-weight":"bold"} }
const _hoisted_34 = { style: {"background":"#fff","color":"#606266"} }
const _hoisted_35 = {
  class: "FPStrend",
  style: {"width":"100%","height":"350px"}
}
const _hoisted_36 = { class: "labelStyle" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"100%","height":"350px"},
  id: "performance_line"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_h7 = _resolveComponent("h7")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_el_card, { class: "tableMinH" }, {
                default: _withId(() => [
                  _createVNode(_component_el_form, {
                    class: "spacForm",
                    size: "mini",
                    model: _ctx.filterList,
                    inline: true
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "日期" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.filterList.date,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterList.date = $event)),
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.allOption('date', true))),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.date,
                                  label: item.date,
                                  value: item.date
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "机型  " }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.allOption('device', true))),
                            modelValue: _ctx.filterList.device,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterList.device = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deviceOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.device_id,
                                  label: item.name,
                                  value: item.device_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "场景" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.allOption('scene', true))),
                            modelValue: _ctx.filterList.scene,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filterList.scene = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sceneOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.chinese,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "测试子类型" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.allOption('subtype', true))),
                            modelValue: _ctx.filterList.subtype,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.filterList.subtype = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subtypeOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.subtype,
                                  label: item.chinese,
                                  value: item.subtype
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "日志" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.allOption('Journa', true))),
                            modelValue: _ctx.filterList.Journa,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.filterList.Journa = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.JournaOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id_test,
                                  label: item.time,
                                  value: item.id_test
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "mini",
                            style: {"height":"28px"}
                          }, {
                            default: _withId(() => [
                              _createVNode("a", {
                                style: {"color":"#fff","text-decoration":"none"},
                                href: _ctx.adbLog.file_path,
                                download: ""
                              }, "下载日志", 8, ["href"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "mini",
                            style: {"height":"28px"},
                            onClick: _ctx.packageBtn
                          }, {
                            default: _withId(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "mini",
                            style: {"height":"28px"},
                            onClick: _ctx.deleteBtn
                          }, {
                            default: _withId(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"]),
                  _createVNode("div", _hoisted_3, [
                    _createVNode("div", _hoisted_4, [
                      _createVNode(_component_h7, { style: {"display":"flex","align-items":"center"} }, {
                        default: _withId(() => [
                          _hoisted_5,
                          _hoisted_6
                        ]),
                        _: 1
                      }),
                      _createVNode("div", null, [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.statistics_input,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.statistics_input = $event)),
                          onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.recordSearch('statistics_input'))),
                          placeholder: "搜索",
                          "prefix-icon": "el-icon-search",
                          size: "mini"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_7, [
                      _withDirectives(_createVNode(_component_el_table, {
                        data: _ctx.getMonitorList.results,
                        border: "",
                        "header-cell-style": {
                  background: '#f5f7fa',
                }
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "type_name",
                            label: "类型",
                            width: "200"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "log_num",
                            label: "数量",
                            width: "100"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "address",
                            label: "内容"
                          }, {
                            default: _withId((scope) => [
                              (scope.row.content.length > 100)
                                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                    key: 0,
                                    content: scope.row.content
                                  }, {
                                    default: _withId(() => [
                                      _createVNode("div", _hoisted_8, [
                                        _createVNode("span", {
                                          id: scope.$index + _ctx.address
                                        }, _toDisplayString(scope.row.content.substring(0, 101)), 9, ["id"]),
                                        _createVNode("i", {
                                          onClick: ($event: any) => (_ctx.btn(scope.row, scope.$index)),
                                          class: "el-icon-circle-plus"
                                        }, null, 8, ["onClick"])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["content"]))
                                : (_openBlock(), _createBlock("div", _hoisted_9, [
                                    _createVNode("div", _hoisted_10, [
                                      _createVNode("span", {
                                        id: scope.$index + _ctx.address
                                      }, _toDisplayString(scope.row.content.substring(0, 101)), 9, ["id"]),
                                      _createVNode("i", {
                                        onClick: ($event: any) => (_ctx.btn(scope.row, scope.$index)),
                                        class: "el-icon-circle-plus"
                                      }, null, 8, ["onClick"])
                                    ])
                                  ]))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      _createVNode(_component_el_pagination, {
                        currentPage: _ctx.currentPage1,
                        "onUpdate:currentPage": _cache[13] || (_cache[13] = ($event: any) => (_ctx.currentPage1 = $event)),
                        "page-size": _ctx.record,
                        layout: "total, prev, pager, next,jumper",
                        total: _ctx.getMonitorList.count,
                        onCurrentChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleCurrentChange('statistics_input')))
                      }, null, 8, ["currentPage", "page-size", "total"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _createVNode(_component_h7, { style: {"display":"flex","align-items":"center"} }, {
                        default: _withId(() => [
                          _hoisted_13,
                          _hoisted_14
                        ]),
                        _: 1
                      }),
                      _hoisted_15
                    ]),
                    _createVNode("div", _hoisted_16, [
                      _createVNode(_component_el_form, {
                        class: "spacForm",
                        size: "mini",
                        model: _ctx.filterList,
                        inline: true
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "日期选择" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.filterList.dateSingle,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.filterList.dateSingle = $event)),
                                multiple: "",
                                "collapse-tags": "",
                                "collapse-tags-tooltip": "",
                                onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.allOption('dateSingle', false))),
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateSingOptions, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.date,
                                      label: item.date,
                                      value: item.date
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"]),
                      _withDirectives(_createVNode(_component_el_table, {
                        data: _ctx.tableData,
                        border: "",
                        "header-cell-style": {
                  background: '#f5f7fa',
                }
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.abdCompare.label, (item) => {
                            return (_openBlock(), _createBlock(_component_el_table_column, {
                              key: item,
                              label: item === 'type_name' ? '类型' : item,
                              prop: item
                            }, null, 8, ["label", "prop"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["data"]), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      _createVNode(_component_el_pagination, {
                        currentPage: _ctx.currentPage3,
                        "onUpdate:currentPage": _cache[17] || (_cache[17] = ($event: any) => (_ctx.currentPage3 = $event)),
                        "page-size": _ctx.statistics,
                        layout: "total, prev, pager, next,jumper",
                        total: _ctx.abdCompare.list?.length,
                        onCurrentChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleCurrentChange('tableData')))
                      }, null, 8, ["currentPage", "page-size", "total"])
                    ])
                  ]),
                  _hoisted_17,
                  _createVNode("div", _hoisted_18, [
                    _createVNode("div", _hoisted_19, [
                      _createVNode(_component_h7, { style: {"display":"flex","align-items":"center"} }, {
                        default: _withId(() => [
                          _hoisted_20,
                          _hoisted_21
                        ]),
                        _: 1
                      }),
                      _createVNode("div", null, [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.record_input,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.record_input = $event)),
                          onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.recordSearch('record_input'))),
                          placeholder: "搜索",
                          "prefix-icon": "el-icon-search",
                          size: "mini"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_22, [
                      _withDirectives(_createVNode(_component_el_table, {
                        data: _ctx.getMonitorList1.results,
                        border: "",
                        "header-cell-style": {
                  background: '#f5f7fa',
                }
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "process_name",
                            label: "进程",
                            width: "200"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "process_id",
                            label: "进程ID",
                            width: "100"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "log_num",
                            label: "数量",
                            width: "100"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "content",
                            label: "内容"
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      _createVNode(_component_el_pagination, {
                        currentPage: _ctx.currentPage2,
                        "onUpdate:currentPage": _cache[21] || (_cache[21] = ($event: any) => (_ctx.currentPage2 = $event)),
                        "page-size": _ctx.statistics,
                        layout: "total, prev, pager, next,jumper",
                        total: _ctx.getMonitorList1.count,
                        onCurrentChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.handleCurrentChange('record_input')))
                      }, null, 8, ["currentPage", "page-size", "total"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_23, [
                    _createVNode("div", _hoisted_24, [
                      _createVNode(_component_h7, { style: {"display":"flex","align-items":"center"} }, {
                        default: _withId(() => [
                          _hoisted_25,
                          _hoisted_26
                        ]),
                        _: 1
                      }),
                      _hoisted_27
                    ]),
                    _createVNode("div", _hoisted_28, [
                      _createVNode(_component_el_form, {
                        class: "spacForm",
                        size: "mini",
                        model: _ctx.filterList,
                        inline: true
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "日期选择" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.filterList.processSingle,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.filterList.processSingle = $event)),
                                multiple: "",
                                "collapse-tags": "",
                                "collapse-tags-tooltip": "",
                                onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.allOption('processSingle', _ctx.fasle))),
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateSingOptions, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.date,
                                      label: item.date,
                                      value: item.date
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"]),
                      _withDirectives(_createVNode(_component_el_table, {
                        data: _ctx.tableProcessData,
                        border: "",
                        "header-cell-style": {
                  background: '#f5f7fa',
                }
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.abdProcessCompare.label, (item) => {
                            return (_openBlock(), _createBlock(_component_el_table_column, {
                              key: item,
                              label: item === 'type_name' ? '类型' : item,
                              prop: item
                            }, null, 8, ["label", "prop"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["data"]), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      _createVNode(_component_el_pagination, {
                        currentPage: _ctx.currentPage4,
                        "onUpdate:currentPage": _cache[25] || (_cache[25] = ($event: any) => (_ctx.currentPage4 = $event)),
                        "page-size": _ctx.statistics,
                        layout: "total, prev, pager, next,jumper",
                        total: _ctx.abdProcessCompare.list?.length,
                        onCurrentChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.handleCurrentChange('tableProcessData')))
                      }, null, 8, ["currentPage", "page-size", "total"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_29, [
                    _createVNode(_component_h7, { style: {"display":"flex","align-items":"center"} }, {
                      default: _withId(() => [
                        _hoisted_30,
                        _hoisted_31
                      ]),
                      _: 1
                    }),
                    _createVNode("table", _hoisted_32, [
                      _createVNode("tr", _hoisted_33, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.trendList, (item) => {
                          return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(item.name), 1))
                        }), 128))
                      ]),
                      _createVNode("tr", _hoisted_34, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.trendList, (item) => {
                          return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(item.data), 1))
                        }), 128))
                      ])
                    ]),
                    _createVNode("div", _hoisted_35, [
                      _withDirectives(_createVNode(_component_el_card, null, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_36, _toDisplayString(_ctx.trend.device_name), 1),
                          _hoisted_37
                        ]),
                        _: 1
                      }, 512), [
                        [_directive_loading, _ctx.loading]
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})